require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("./Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var List = function List(_ref) {
  var _ref$border = _ref.border,
      border = _ref$border === void 0 ? true : _ref$border,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? "gainsboro" : _ref$borderColor,
      padding = _ref.padding,
      margin = _ref.margin,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 10 : _ref$count;
  return _react["default"].createElement("ul", {
    style: {
      margin: margin || 0,
      padding: 0,
      listStyleType: "none"
    }
  }, Array.from(Array(count), function (e, i) {
    return _react["default"].createElement("li", {
      key: i,
      style: {
        borderBottom: border ? "1px solid ".concat(borderColor) : false,
        padding: padding
      }
    }, _react["default"].createElement(_Box["default"], {
      height: 30,
      width: "30%"
    }), _react["default"].createElement(_Box["default"], {
      height: 15
    }));
  }));
};

var _default = List;
exports["default"] = _default;